import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ForuscareService } from '../foruscare/foruscare.service';
import { Account } from '../../models/account';

@Injectable({
  providedIn: 'root'
})
export class CustomerOnboardingService {

  private handleError: HandleError;
  constructor(
    public http: HttpClient,
    public fourscareService: ForuscareService,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('Customer Onboarding Service');
  }

  inviteServiceProviderWithCaptcha(vendorInfo: any): Observable<any> {
    return this.http.post<any>(this.fourscareService.hostUrl + "/forus-onboarding-service/onboarding/captcha/customer/invite",
      vendorInfo)
      .pipe(
        catchError(this.handleError('vendor invite'))
      );
  }

  inviteServiceProvider(vendorInfo: any): Observable<any> {
    return this.http.post<any>(this.fourscareService.hostUrl + "/forus-onboarding-service/onboarding/customer/invite",
      vendorInfo)
      .pipe(
        catchError(this.handleError('vendor invite'))
      );
  }

  getInvitedVendors(): Observable<any> {
    return this.http.post<any>(this.fourscareService.hostUrl
      + "/forus-onboarding-service/onboarding/invited/users/type?count=10000&offset=0", { type: "vendor" })
      .pipe(
        catchError(this.handleError('listing invited vendors'))
      );
  }

  resendInviteLink(id): Observable<any> {
    return this.http.post<any>(this.fourscareService.hostUrl + "/forus-onboarding-service/onboarding/resend/inviteLink", { id: id })
      .pipe(
        catchError(this.handleError('resend invite link by id'))
      );
  }

  validateVendorDetails(field: string, type: string) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/serviceProvider/isFieldExists",
      { field: field, type: type })
      .pipe(
        catchError(this.handleError('validate vendor details'))
      );
  }

}
